/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * LocationStatusDtoBase
 * auto generated base class for the model LocationStatusDtoModel.
 */
export const LocationStatusDtoModelBase = ModelBase
  .named('LocationStatusDto')
  .props({
    __typename: types.optional(types.literal("LocationStatusDto"), "LocationStatusDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LocationStatusDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromLocationStatusDto() {
  return new LocationStatusDtoModelSelector()
}

export const locationStatusDtoModelPrimitives = selectFromLocationStatusDto().name
